import { render } from "./Publication.vue?vue&type=template&id=93b30d74"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__